<section class="questions-section">
    <h2 class="questions-title">
        {{'PYMES.OBJECIONES-VENTAS.TITLE' | translate }}
    </h2>

    <div class="questions-table">
        <div class="questions-row" *ngFor="let row of questionRows; let i = index; trackBy: trackByRow">
            <div class="question-item">
                <div class="question-header">
                    <div class="benefit-icon">
                        <img class="benefit-icon__image" [src]="'assets/images/pymes/X.png'" />
                        <!-- {{ row.left.number }} -->
                    </div>

                    <div class="question-title-text">
                        {{ row.left.title }}
                    </div>
                </div>

                <div class="question-body" *ngIf="row.left.description || row.left.bullets?.length">
                    <div class="question-body-spacer"></div>

                    <div class="question-body-content">
                        <div class="question-description" *ngIf="row.left.description">
                            <span class="section-heading__check">✓</span>
                            {{ row.left.description }}
                        </div>

                        <ul class="question-list" *ngIf="row.left.bullets?.length">
                            <li *ngFor="let bullet of row.left.bullets">
                                <span class="section-heading__check">✓</span>
                                {{ bullet }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="question-item" *ngIf="row.right">
                <div class="question-header">
                    <div class="benefit-icon">
                        <img class="benefit-icon__image" [src]="'assets/images/pymes/X.png'" />
                        <!-- {{ row.left.number }} -->
                    </div>

                    <div class="question-title-text">
                        {{ row.right.title }}
                    </div>
                </div>

                <div class="question-body" *ngIf="row.right.description || row.right.bullets?.length">
                    <div class="question-body-spacer"></div>

                    <div class="question-body-content">
                        <div class="question-description" *ngIf="row.right.description">
                            <span class="section-heading__check">✓</span>
                            {{ row.right.description }}
                        </div>

                        <ul class="question-list" *ngIf="row.right.bullets?.length">
                            <li *ngFor="let bullet of row.right.bullets">
                                <span class="section-heading__check">✓</span>
                                {{ bullet }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>